﻿import {translation} from "@2d-front-monorepo/core";
import {
	AddressComponent,
	AttachmentsComponent,
	EntityHistoryStatusComponent,
	IntegraHolderData,
	PermitFullEntityResult, RequiredResidencyProperties, ResidencyId,
	ResidencyResult,
	Zones
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {API_ENDPOINT} from "../../../api-endpoint";

const filesPrefix = API_ENDPOINT.fileDownload;

export function ResidencyComponent({holderData, residency, hiddenEntityProperties, showStatus}: {
	holderData: IntegraHolderData,
	residency: PermitFullEntityResult<ResidencyId, ResidencyResult>,
	hiddenEntityProperties: RequiredResidencyProperties,
	showStatus: boolean
}): JSX.Element {
	const zone = Zones.get(holderData, residency.entity.zoneId);

	return <div className="card card--residency">
		<header className="layout horizontal aligned middle">
			<h5 className="flex">{translation(PermitTranslations.residency)}</h5>
			{showStatus && <EntityHistoryStatusComponent status={residency}/>}
		</header>
		<hr className="no-margin"/>
		<div className="columns gap padded">
			<dl className="title-desc col25">
				<dt>{translation(PermitTranslations.zone)}</dt>
				<dd>{zone!.name || zone!.id}</dd>
			</dl>
			<dl className="title-desc col50">
				<dt>{translation(PermitTranslations.address)}</dt>
				<dd><AddressComponent value={residency.entity} hiddenEntityProperties={hiddenEntityProperties}/></dd>
			</dl>
			<AttachmentsComponent entity={residency.entity} linkPrefix={filesPrefix} className="col25"/>
		</div>
	</div>
}
